import type { Opinion, Profile, ZmanId } from "@kedaat/engine";
import { OPINIONS } from "./opinions";
import { PROFILES } from "./profiles";

export { DAYS, OPINIONS } from "./opinions";
export { DEFAULT_PROFILE_ID, PROFILES } from "./profiles";
export { ZMANIM, type ZmanInfo } from "./zmanim";

export const OPINIONS_BY_ID: ReadonlyMap<string, Opinion> = new Map(OPINIONS.map((o) => [o.id, o]));

export function opinionsFor(zman: ZmanId): Opinion[] {
  return OPINIONS.filter((o) => o.zman === zman);
}

export function findProfile(id: string): Profile | undefined {
  return PROFILES.find((p) => p.id === id);
}

export type Overrides = Partial<Record<ZmanId, string>>;

/**
 * The opinion chosen for every zman: the profile's choice, unless the user overrode it.
 * Invalid overrides (unknown id, or an opinion for a different zman) are ignored.
 */
export function resolveOpinions(
  profile: Profile,
  overrides: Overrides = {},
): Record<ZmanId, Opinion> {
  const result = {} as Record<ZmanId, Opinion>;
  for (const [zman, profileChoice] of Object.entries(profile.opinions) as [ZmanId, string][]) {
    const override = overrides[zman] ? OPINIONS_BY_ID.get(overrides[zman]) : undefined;
    const chosen = override?.zman === zman ? override : OPINIONS_BY_ID.get(profileChoice);
    if (!chosen)
      throw new Error(`Profile ${profile.id} references unknown opinion ${profileChoice}`);
    result[zman] = chosen;
  }
  return result;
}
